(function () {
  var isLoading = false;
  var retryTimer = null;
  var periodicTimer = null;
  var requestCount = 0;
  var MAX_REQUESTS_PER_PAGE = 4;

  function safeText(value) {
    return value == null ? '' : String(value);
  }

  function postViaProxyWithFallback(urls, payload) {
    return urls.reduce(function (chain, url) {
      return chain.then(function (response) {
        if (response) return response;
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (nextResponse) {
          return nextResponse.status !== 404 ? nextResponse : null;
        });
      });
    }, Promise.resolve(null)).then(function (response) {
      return response || new Response(null, { status: 404, statusText: 'Not Found' });
    });
  }

  function setBadges(unreadTicketCount) {
    var count = Number(unreadTicketCount || 0);
    var profileBadges = document.querySelectorAll('[data-upng-profile-unread-badge]');
    var messageLinks = Array.from(
      document.querySelectorAll(
        '.upng-account-dropdown a[href*="mis-mensajes"], .upng-account-dropdown a[href*="mis_mensajes"], .upng-my-account-menu a[href*="mis-mensajes"], .upng-my-account-menu a[href*="mis_mensajes"], a.area-menu-item[href*="mis-mensajes"], a.area-menu-item[href*="mis_mensajes"]'
      )
    );

    profileBadges.forEach(function (badge) {
      badge.hidden = count <= 0;
    });

    // Remove legacy badges injected by app scripts to avoid duplicates.
    document.querySelectorAll('.upng-account-dropdown .upng-messages-unread-badge, .upng-my-account-menu .upng-messages-unread-badge')
      .forEach(function (legacyBadge) {
        legacyBadge.remove();
      });

    messageLinks.forEach(function (link) {
      var badge = link.querySelector('.upng-global-messages-unread-badge');
      if (count <= 0) {
        if (badge) badge.remove();
        return;
      }

      if (!badge) {
        badge = document.createElement('i');
        badge.className = 'upng-global-messages-unread-badge';
        badge.setAttribute('aria-hidden', 'true');
        if (window.getComputedStyle(link).position === 'static') {
          link.style.position = 'relative';
        }
        link.appendChild(badge);
      }
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.setAttribute('title', count > 0 ? String(count) : '');
    });
  }

  function pickContext() {
    var contexts = Array.from(document.querySelectorAll('[data-upng-messages-badge-context="true"]'));
    if (!contexts.length) return null;

    return contexts.find(function (ctx) {
      return safeText(ctx.dataset.companyId) && safeText(ctx.dataset.companyExternalId);
    }) || null;
  }

  async function loadUnreadCount() {
    if (isLoading) return;
    if (requestCount >= MAX_REQUESTS_PER_PAGE) return;
    var context = pickContext();
    if (!context) return;

    var companyId = safeText(context.dataset.companyId);
    var companyExternalId = safeText(context.dataset.companyExternalId);
    var isMainBranch = safeText(context.dataset.isMainBranch).toLowerCase() === 'true';
    var currentLocationExternalId = safeText(context.dataset.currentLocationExternalId);
    var shop = safeText(context.dataset.shop) || ((typeof Shopify !== 'undefined' && Shopify.shop) ? Shopify.shop : '');

    if (!companyId || !companyExternalId || !shop) return;

    var locationExternalIds = [];
    if (!isMainBranch && currentLocationExternalId) {
      locationExternalIds.push(currentLocationExternalId);
    }

    try {
      isLoading = true;
      requestCount += 1;
      var response = await postViaProxyWithFallback(
        [
          '/apps/upango-b2b/companies/messages-summary/',
          '/apps/upango-b2b/api/companies/messages-summary'
        ],
        {
          companyId: companyId,
          companyExternalId: companyExternalId,
          includeAllCompanyMessages: isMainBranch,
          locationExternalIds: locationExternalIds,
          shop: shop
        }
      );

      if (!response.ok) return;
      var payload = await response.json();
      var unreadTicketCount = Number(payload && payload.data ? payload.data.unreadTicketCount : 0);
      setBadges(unreadTicketCount);
    } catch (_error) {
      // Silent fail: never break header rendering for badge loading errors.
    } finally {
      isLoading = false;
    }
  }

  function scheduleRetry() {
    if (retryTimer) return;
    retryTimer = setTimeout(function () {
      retryTimer = null;
      loadUnreadCount();
    }, 1000);
  }

  function startPeriodicRefresh() {
    if (periodicTimer) return;
    periodicTimer = setInterval(function () {
      if (requestCount >= MAX_REQUESTS_PER_PAGE) {
        clearInterval(periodicTimer);
        periodicTimer = null;
        return;
      }
      loadUnreadCount();
    }, 30000);
  }

  function boot() {
    loadUnreadCount();
    scheduleRetry();
    startPeriodicRefresh();
  }

  document.addEventListener('DOMContentLoaded', boot);

  window.addEventListener('upng:messages-unread', function (event) {
    var unreadTicketCount = Number(event && event.detail ? event.detail.unreadTicketCount : 0);
    setBadges(unreadTicketCount);
  });

  // No extra visibility/focus hooks to keep request volume predictable.

  // Intentionally no MutationObserver here to avoid excessive network calls on dynamic DOM updates.
})();
